import React from "react";
import { Col, Row, Container, Image } from "react-bootstrap";
import imageLists from "../../assets/images/partner/list.json";

interface IProps {
  title: string;
  folder: string;
}

function PartnerList({ title, folder }: IProps) {
  const images = Object.entries(imageLists)
    .filter(([folderName, content]) => {
      return content !== null && folderName === folder;
    })
    .map(([_, content]) => {
      return Object.values(content).map((c) => {
        return require(`../../assets/images/partner/${folder}/${c}`);
      });
    })[0];

  return (
    <div className="my-4 py-4">
      <Container>
        <div className="fw-extra-bold text-size-sub-headline">{title}</div>
        <Row className="align-items-center text-center">
          {images.map((a, idx) => {
            return (
              <Col
                xl={2}
                lg={3}
                md={4}
                sm={6}
                xs={12}
                className="mt-4 mb-2"
                key={`partnerrow1-${idx}`}
              >
                <div className="">
                  <Image src={a} fluid />
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}

export default PartnerList;
